<template>
  <div class="main">
    <div class="box">
      <div class="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/purchaseRequisition' }">采购申请</el-breadcrumb-item>
          <el-breadcrumb-item>订单编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="table">
        <div class="table-nav">
          <div class="table-nav-l">
            备注：<el-input type="text" placeholder="请输入内容" v-model="remarks" maxlength="50" show-word-limit></el-input>
          </div>
          <div class="table-nav-r" @click="addItem">
            添加物料
          </div>
        </div>
        <div class="table-box">
          <el-table
          height="66.5vh"
          :data="addList"
          style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="80">
            </el-table-column>
            <el-table-column
              prop="materialTypeName"
              label="材料类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="materialName"
              label="材料名称">
            </el-table-column>
            <el-table-column
              prop="materialModel"
              label="材料型号">
            </el-table-column>
            <el-table-column
              prop="materialBrand"
              label="材料品牌">
            </el-table-column>
            <el-table-column
              prop="materialManufacturer"
              label="生产厂家">
            </el-table-column>
            <el-table-column
              prop="materialSupplier"
              label="供应商">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="数量"
              width="100">
            </el-table-column>
          </el-table>
        </div>
        <div class="btns">
          <div class="btn-l" @click="exit">取消</div>
          <div class="btn-r" @click="success">确认</div>
        </div>
        <el-dialog
        lock-scroll
          :visible.sync="dialogVisible"
          top="12vh"
          width="98%"
          :show-close="false"
          >
          <div class="tab-box">
            <div class="table1">
              <div class="nav">
                <div class="input"><el-input v-model="materialName" placeholder="请输入物料名称" clearable @change="getList"></el-input></div>
                <div class="input"><el-input v-model="materialSupplier" placeholder="请输入供应商名称" clearable @change="getList"></el-input></div>
                <el-button style="margin-left:2%" type="primary" @click="getList">搜索</el-button>
              </div>
              <div class="title">供应商库物料列表</div>
              <el-table
              border
                :data="list"
                height="58.6vh"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="materialName"
                  label="材料名称">
                </el-table-column>
                <el-table-column
                  prop="materialModel"
                  label="材料型号">
                </el-table-column>
                <el-table-column
                  prop="materialBrand"
                  label="材料品牌"
                  >
                </el-table-column>
                <el-table-column
                  prop="materialSupplier"
                  label="供应商名称"
                  >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="addListItem(scope.row)">添加</el-button>
                  </template>
                </el-table-column>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 40, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
            <div class="table2">
              <div class="title">添加列表</div>
              <el-table
              border
                :data="addList"
                height="69vh"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="materialName"
                  label="材料名称"
                  >
                </el-table-column>
                <el-table-column
                  prop="materialModel"
                  label="材料型号">
                </el-table-column>
                <el-table-column
                  prop="materialBrand"
                  label="材料品牌"
                  >
                </el-table-column>
                <el-table-column
                  prop="materialSupplier"
                  label="供应商名称"
                  >
                </el-table-column>
                <el-table-column
                  prop="unitPrice"
                  label="单价(元)">
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="数量"
                  >
                  <template slot-scope="scope">
                    <div class="input-s">
                      <el-input v-model="scope.row.amount" size="mini" min="0" type="number" placeholder="请输入内容"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="materialUnitTypeName"
                  label="单位"
                  >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <div class="btn-s"
                      @click="delListItem(scope.$index,scope.row)">删除</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      data: '',
      tableData: [{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },{
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          }, {
            date: '1',
            name: '王小虎',
            address: '上海'
          },],
      dialogVisible:false,
      pageNum:1,
      pageSize:10,
      List:[],
      addList:[],
      ListS:[],
      total:0,
      remarks:'',
      indexA:true,
      materialSupplier:'',
      materialName:''
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    
    handleSizeChange(val){
      console.log('chufale',val)
      this.pageSize = val
      this.pageNum = 1
      this.getList()
    },
    handleCurrentChange(val){
      this.pageNum = val
      this.getList()
    },
    success(){
      if(this.addList.length!==0){
        let itemB ={}
      this.addList.forEach((item,index)=>{
        itemB = {supplierId:item.id,amount:item.amount}
        this.ListS.push(itemB)
      })
      console.log(this.ListS)
      myHttp.findProjectProcessConfig({
        projectId:util.session.get('groupId')
      }).then(res=>{
        console.log(res,'222222')
        if(res.data.data.projectProcessConfig.length!==0){
          this.applyPurchasePlan()
        }else{
          this.$confirm('未设置项目流程，审批将会自动通过！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.applyPurchasePlan()
        }).catch(() => {
                  
        });
        }
      })
      }else{
        this.$message({
          message: '请添加物料',
          type: 'warning'
        });
      }
    },
    applyPurchasePlan(){
      myHttp.applyPurchasePlan({
        projectId:util.session.get('groupId'),
        remarks:this.remarks,
        purchaseSupplierPlanVos:this.ListS
      }).then(res=>{
        if(res.data.code==200){
          this.$message({
            message:`${res.data.msg}`,
            type:'success'
          })
          this.$router.go(-1)
        }
      })
    },
    delListItem(index,item){
      this.addList.splice(index,1)
    },
    addListItem(item1){
      console.log(item1)
      this.addList.forEach((item)=>{
        if(item.id===item1.id){
          this.indexA=false
          this.$message({
            message:'请勿重复添加',
            type:'warning'
          })
        }
      })
      if(this.indexA){
        this.addList.push(item1)
      }
      this.indexA=true
    },
    addItem(){
      this.dialogVisible = true
    },
    exit(){
      this.$router.go(-1)
    },
    getList(){
      myHttp.getProProjectSupplierPage({
        materialName:this.materialName,
        materialSupplier:this.materialSupplier,
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }).then(res=>{
        console.log(res,'9999')
        if(res.data.code==200){
          this.list = res.data.data.pageInfo.list
          this.total = res.data.data.pageInfo.total
        }
      })
    }
  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
.main{
  flex: 1;
  height: 100%;
  background-color: #F3F8FC;
  padding-left:8px ;
  padding-right:24px ;
}
.table{
  height: 83vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0vw 0vw 0.4vw 0vw 
		rgba(105, 159, 204, 0.5);
}
.header{
  display: flex;
  min-height: 6vh;
  line-height: 6vh;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.el-pagination {
    padding: 1.2vh 1vh !important;
}
.el-breadcrumb{
  font-size: 18px;
  display: flex;
  align-items: center;
}
::v-deep .is-link {
  font-weight: 500 !important;
}
.table-nav{
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;
}
.table-nav-l{
  display: flex;
  width: 20%;
  align-items: center;
  margin-left: 2%;
}
.table-nav-r{
  background-color: #0b62f0;
  color: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 100px;
  margin-right: 2%;
}
.table-nav-r:hover{
  cursor: pointer;
  opacity: 0.7;
}
.table-box>::v-deep .el-table th.el-table__cell{
  background-color: #e6e6e6 !important;
}
.table-box{
  padding: 0 2%;
}
.el-table{
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}
.btns>.btn-l{
  width: 101px;
height: 41px;
background: #FFFFFF;
border: 1px solid #BBBBBB;
border-radius: 4px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 41px;
margin-right: 25px;
}
.btns>.btn-r{
  width: 100px;
height: 40px;
background: #3F9EFF;
border-radius: 4px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #FEFEFE;
line-height: 40px;
margin-right: 25px;
}
.btns{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn-l:hover, .btn-r:hover{
  cursor: pointer;
  opacity: 0.7;
}
.tab-box{
  display: flex;
  justify-content: space-between;
}
.table1{
  width: 49%;
  height: 75vh;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
border-radius: 6px;
}
.table2{
  width: 49%;
  height: 75vh;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
border-radius: 6px;
}
::v-deep .el-dialog__header{
  padding: 0 !important;
}
.nav{
  display: flex;
  margin-top: 1%;
  margin-bottom: 1%;

}
.input{
  width: 28%;
  margin-left: 1%;
}
.title{
  background: #E6E6E6;
  font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #666666;
line-height: 60px;
}
.el-dialog__body{
  padding-bottom: 0;
}
.el-pagination{
background: #E6E6E6;
padding: 0.7vh 1vh !important
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar, ::v-deep .is-scrolling-right::-webkit-scrollbar{
height: 0 !important;
}
.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-s{
  width: 51px;
height: 26px;
background: #FFFFFF;
border: 1px solid #C10404;
border-radius: 4px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #FF0000;
line-height: 26px;
}
.btn-s:hover{
  cursor: pointer;
  opacity: 0.7;
}

.input-s{
  width: 100%;
height: 100%;
border-radius: 6px;
overflow: hidden;
}
.inputNum{
  width: 40px;
}
::v-deep .el-input__inner{
  padding-right: 0 !important;
}
</style>